import { createRouter, createWebHistory } from 'vue-router';
import HomeView from '../views/HomeView.vue';
import AboutUs from '../views/AboutUsView.vue';
import Sucursales from '../views/SucursalesView.vue';
import Portafolio from '@/views/PortafolioView.vue';
import Bloquera from '@/views/BloqueraView.vue';
import Carrito from '@/views/CarritoView.vue';
import Productos from '@/views/ProductosView.vue';
import OfertasView from '@/views/OfertasView.vue';
import ProductosOfertas from '@/views/ProductosOfertaView.vue';

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
  },
  {
    path: '/about',
    name: 'about',
    component: AboutUs,
  },
  {
    path: '/sucursales',
    name: 'sucursales',
    component: Sucursales,
  },
  {
    path: '/portafolio',
    name: 'portafolio',
    component: Portafolio,
  },
  {
    path: '/bloquera',
    name: 'bloquera',
    component: Bloquera,
  },
  {
    path: '/carrito',
    name: 'carrito',
    component: Carrito,
  },
  {
    path: '/productos',
    name: 'productos',
    component: Productos,
  },
  {
    path: '/ofertas',
    name: 'ofertas',
    component: OfertasView,
  },
  {
    path: '/productos-ofertas',
    name: 'productos-ofertas',
    component: ProductosOfertas,
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
